module.exports = __webpack_public_path__ + "static/gradient_blue-3426bf5c91b95492a8f1391cf9444c85.jpg";